<form (keydown.enter)="onButtonClick()" class="free-trial-form">
  <div class="email-collector-container" [class.light-theme]="theme === 'light'" [class.error]="emailError">
    <div class="input-container">
      <input
        #emailInput
        class="email-input"
        type="text"
        [placeholder]="inputPlaceholder"
        [formControl]="emailFormControl"
        [value]="emailFormControl.value"
        (blur)="onBlur()"
      />
      <svg-icon *ngIf="showValidIcon && !emailError" key="tickmark-in-circle-filled"></svg-icon>
      <svg-icon *ngIf="emailError" key="exclamation-in-circle" class="error-icon"></svg-icon>
    </div>
  </div>
  <div [@errorAnimation]="emailError ? 'invalid' : 'valid'" class="error-hint-container">
    <p class="error-hint">
      {{ emailError | translate }}
    </p>
  </div>
  <button type="button" class="marketing-button large" [disabled]="!emailFormControl.value || emailError" (click)="onButtonClick()">
    <span [class.d-none]="isLoading">{{ buttonText }}</span>
    <div class="d-none" [class.d-flex]="isLoading">
      <osn-shared-loading-spinner [size]="25" type="white"></osn-shared-loading-spinner>
    </div>
  </button>
</form>
